module.exports = __webpack_public_path__ + "img/feirao-apolar-selo-superdesconto.6f6a7626.webp";